import * as SegmentApi from './segment';
import * as ViewerApi from './viewer';
import * as FilterApi from './filter';
import * as SearchApi from './search';
import * as CreativeApi from './creative';
import * as TeamApi from './team';
import * as BrandsApi from './brands';
import * as ReportApi from './report';
import * as TrackingApi from './tracking';
import * as MediaValueApi from './mediavalue';
import * as UserApi from './user';
import * as ComplianceApi from './compliance';
import * as ApiTokenApi from './apiToken';

const rqApi = {
    ...CreativeApi,
    ...FilterApi,
    ...SearchApi,
    ...SegmentApi,
    ...TeamApi,
    ...ViewerApi,
    ...BrandsApi,
    ...ReportApi,
    ...TrackingApi,
    ...MediaValueApi,
    ...UserApi,
    ...ComplianceApi,
    ...ApiTokenApi
};

export default rqApi;
